import Head from 'next/head'

import { brandName, isPresident } from '@src/utils'

export const CustomHead = ({ title }: { title?: string }) => {
  const titleWithBrand = title ? `${title} | ${brandName}` : brandName

  return (
    <Head>
      <title>{titleWithBrand}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="noindex, nofollow" />
      <meta
        name="facebook-domain-verification"
        content="a6q5onravbijb32bn6litfb6q5j99a"
      />
      <link
        rel="icon"
        href={isPresident() ? '/president-card-favicon.ico' : '/favicon.ico'}
      />
    </Head>
  )
}
